/**
 * Wrapper de compatibilidade temporário para migração de Inertia.js → React Router
 * TODO: Migrar componentes gradualmente para usar React Router diretamente
 */

import {
  Link as RouterLink,
  useLocation,
  type LinkProps as RouterLinkProps,
} from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { sngpcMenu } from '../data/menu';
import { createElement, forwardRef, type ReactNode } from 'react';

// Tipos compatíveis com Inertia
export interface PageProps<T = Record<string, any>> {
  auth: {
    user: any;
    empresa?: any;
  };
  menu?: any[];
  [key: string]: any;
}

export interface Page<T = Record<string, any>> {
  component: string;
  props: PageProps<T>;
  url: string;
  version: string | null;
}

// Hook usePage simulado
export function usePage<T = PageProps>(): Page<T> {
  const location = useLocation();
  const { user, empresa } = useAuth();
  
  return {
    component: '', // Não usado em React Router
    props: {
      auth: {
        user,
        empresa,
      },
      menu: sngpcMenu, // Menu do SNGPC
    } as PageProps<T>,
    url: location.pathname + location.search,
    version: null,
  };
}

type CompatLinkProps = Omit<RouterLinkProps, 'to' | 'prefetch'> & {
  href: string;
  prefetch?: boolean | string;
  preserveScroll?: boolean;
  preserveState?: boolean;
};

// Adapta a API de links do Inertia para o React Router durante a migração.
export const Link = forwardRef<HTMLAnchorElement, CompatLinkProps>(
  ({ href, prefetch: _prefetch, preserveScroll: _preserveScroll, preserveState: _preserveState, ...props }, ref) =>
    createElement(RouterLink, { ref, to: href, ...props }),
);
Link.displayName = 'InertiaCompatLink';

// Head component (não faz nada em SPA - só para compatibilidade)
export function Head({ title }: { title?: string; children?: ReactNode }) {
  if (title) {
    document.title = title;
  }
  return null;
}

// Router object simulado
export const router = {
  visit: (url: string, options?: any) => {
    window.location.href = url;
  },
  get: (url: string, data?: any, options?: any) => {
    const query = data ? '?' + new URLSearchParams(data).toString() : '';
    window.location.href = url + query;
  },
  post: (url: string, data?: any, options?: any) => {
    console.warn('router.post não implementado - use API fetch');
  },
  put: (url: string, data?: any, options?: any) => {
    console.warn('router.put não implementado - use API fetch');
  },
  patch: (url: string, data?: any, options?: any) => {
    console.warn('router.patch não implementado - use API fetch');
  },
  delete: (url: string, options?: any) => {
    console.warn('router.delete não implementado - use API fetch');
  },
  reload: (options?: any) => {
    window.location.reload();
  },
  on: (event: string, callback: (e: any) => void) => {
    // Stub - não dispara eventos
    return () => {};
  },
};
